export default __webpack_public_path__ + "static/media/radio-onyx-deselected.e5608f1f.svg";